import analytics from '../analytics/analytics';
import fetchWithTimeout from '../utils/fetchWithTimeout';
const CREATE_BASKET_MUTATION = `
mutation CreateBasket($basketPayload: CreateBasketPayload) {
  createBasket(basketPayload: $basketPayload) {
    checkoutUrl
  }
}
`;
export const createBasketRequest = options => {
  const {
    appc,
    hotelOptions,
    cguid,
    rguid
  } = options;
  const {
    itemKey,
    itemType = 'STAY',
    priceKey,
    nightlyRateIncludingTaxesAndFees,
    minCurrencyCode = 'USD',
    minCurrencyCodeSymbol = '$'
  } = hotelOptions;
  const requestBody = {
    operationName: 'CreateBasket',
    query: CREATE_BASKET_MUTATION,
    variables: {
      basketPayload: {
        item: {
          itemKey,
          itemType,
          priceKey
        },
        meta: {
          appc,
          cguid,
          rguid,
          plf: 'PCLN',
          gpcd: 'PCLN',
          pointOfSale: {
            countryCode: 'US',
            languageCode: 'ENG',
            currencyCode: 'USD'
          },
          authToken: null
        },
        price: {
          currencyCode: minCurrencyCode,
          currencySymbol: minCurrencyCodeSymbol,
          payment: {
            total: Number(nightlyRateIncludingTaxesAndFees)
          }
        }
      }
    }
  };
  fetchWithTimeout(`/pws/v0/pcln-graph/?gqlOp=CreateBasket`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json'
    }
  }, 10000).then(res => res.json()).then(createBasketResponse => {
    var _a, _b;
    if ((_b = (_a = createBasketResponse === null || createBasketResponse === void 0 ? void 0 : createBasketResponse.data) === null || _a === void 0 ? void 0 : _a.createBasket) === null || _b === void 0 ? void 0 : _b.checkoutUrl) {
      const ref = window.open(createBasketResponse.data.createBasket.checkoutUrl, '_blank');
      if (!ref) {
        alert('Please allow pop-ups in your browser. Thanks!');
      }
    } else {
      throw new Error('no checkout url');
    }
  }).catch(err => {
    alert('Redirect failed. Please retry or use the detail link. Thanks!');
    analytics.logError({
      message: 'Error creating basket',
      error: err.message
    });
  });
};